<script setup lang="ts">
import { useCommunityMenu } from '@/composables/useCommunityMenu';
import type { CommunityDto } from '@/services/types/api.types';
import { useCommunityStore } from '@/stores';

const communityStore = useCommunityStore();
const entries = useCommunityMenu();

const handleItemClick = async (evt: Event, community: CommunityDto) => {
  evt.preventDefault();
  await communityStore.switchCommunity(community, true);
};
</script>

<template>
  <q-menu>
    <q-list>
      <template v-for="entry in entries" :key="entry.key">
        <q-item-label v-if="entry.header" header>{{ entry.label }}</q-item-label>
        <q-item v-else clickable v-close-popup @click="(evt) => handleItemClick(evt, entry.community)">
          <q-item-section>
            <q-item-label>{{ entry.label }}</q-item-label>
            <q-item-label v-if="entry.caption" caption>{{ entry.caption }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </q-menu>
</template>
